import { render, staticRenderFns } from "./ZwyCalendarRoom.vue?vue&type=template&id=5a1b378b&scoped=true"
import script from "./ZwyCalendarRoom.vue?vue&type=script&lang=js"
export * from "./ZwyCalendarRoom.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a1b378b",
  null
  
)

export default component.exports